import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiGetFetchPackages, apiGetFetchStates, apiUpdatePackages, apiGetFetchCharacters, apiGetFetchAuthors, apisavePackages, apiUpdatePackagesCustom, apiUpdatePackagesCharacterOptionMapCustom, apiPublishPacakge, apiGetFetchPackageHistoryList, apiRestorePackageVersion, apiSaveAssignVersion, apiAddCustomCharacter, apiUpdateCustomCharacter, apiDeleteCustomCharacter, apiGetDateLabels } from 'services/PackageService';

export const getPackages = createAsyncThunk('cropCycles/data/getPackages', async (params) => {
    const response = await apiGetFetchPackages(params)
    return { ...response.data, params };
})

export const getPackageHistoryList = createAsyncThunk('cropCycles/data/getPackageHistoryList', async (params) => {
    const response = await apiGetFetchPackageHistoryList(params)
    return { ...response.data, params };
})

export const getStates = createAsyncThunk('cropCycles/data/getStates', async (params) => {
    const response = await apiGetFetchStates(params)
    return response.data;
})

export const getCharacters = createAsyncThunk('cropCycles/data/getCharacters', async (params) => {
    const response = await apiGetFetchCharacters(params)
    return response.data;
})

export const getAuthors = createAsyncThunk('cropCycles/data/getAuthors', async (params) => {
    const response = await apiGetFetchAuthors(params)
    return response.data;
})

// Custom Character Thunks
export const addCustomCharacter = createAsyncThunk('cropCycles/data/addCustomCharacter', async (data) => {
    const response = await apiAddCustomCharacter(data)
    return response.data;
})

export const updateCustomCharacter = createAsyncThunk('cropCycles/data/updateCustomCharacter', async (data) => {
    const response = await apiUpdateCustomCharacter(data)
    return response.data;
})

export const deleteCustomCharacter = createAsyncThunk('cropCycles/data/deleteCustomCharacter', async (data) => {
    const response = await apiDeleteCustomCharacter(data)
    return response.data;
})

export const getDateLabels = createAsyncThunk('cropCycles/data/getDateLabels', async () => {
    const response = await apiGetDateLabels()
    return { ...response.data };
})

const initSelectDistricts = {
    selectedState: '',
    selectedDistrict: ''
}

const initSelectedCharacterMap = {
    selectedCharacter: '',
    selectedOption: '',
    custom: null
}

const initSelectedAuthor = {
    selectedAuthor: ''
}

export const initPackages = {
    total: 0,
    loading: false,
    pageIndex: 1,
    pageSize: 5,
    showTableData: [],
    filterTableData: [],
    query: '',
    sort: {
        order: '',
        key: ''
    }
}
export const initBasiCPackageDetails = {
    packageId: '',
    packageName: '',  //
    characters: [],  //
    districts: [],  //
    packageType: '',  // 
    duration: '',   //
    active: true, //
    cropCycleId: '', //
    authorId: [],  //
    partnerId: '',
    packageDescription:"",
    customCharacters: [],
    practice_start_date:"",
}
const packages = createSlice({
    name: 'packages',
    initialState: {
        isFormPackage: false,
        states: [],
        charactersList: [],
        usersList: [],
        packagesList: initPackages,
        createDistricts: initSelectDistricts,
        packagesTypes: [{ label: 'Annual', value: 'Annual' }, { label: 'Perennial', value: 'Perennial' }],
        packageFormData: initBasiCPackageDetails,
        createCharacterOptionMap: initSelectedCharacterMap,
        createAuthor: initSelectedAuthor,
        packagesTimeLineOption: [],
        selectedConnectId: '',
        initPackageBread: [],
        cropName:'',
        packageName:'',
        packageHistoryList:[],
        dateLabelsList:[],
    },
    reducers: {
        resetpackageFormData: (state, action) => {
            state.packageFormData = action.payload
        },
        updatecreateAuthor: (state, action) => {
            state.createAuthor = action.payload
        },
        updateCharacterOptionMap: (state, action) => {
            state.createCharacterOptionMap = action.payload
        },
        updateCreateDisctrict: (state, action) => {
            state.createDistricts = action.payload
        },
        updateIsPackage: (state, action) => {
            state.isFormPackage = action.payload
        },
        updateFilterData: (state, action) => {
            state.packagesList.filterTableData = action.payload
        },
        updatePageSize: (state, action) => {
            state.packagesList.pageSize = action.payload
        },
        updatePageIndex: (state, action) => {
            state.packagesList.pageIndex = action.payload
        },
        updateQuery: (state, action) => {
            state.packagesList.query = action.payload
        },
        updateAllData:(state, action)=>{
            state.packagesList.showTableData = action.payload;
        },
        updateAllDataLength:(state, action)=>{
            state.packagesList.total = action.payload
        },
        updateListData : (state, action)=>{ //!
            let {showTableData, filterTableData} = action.payload;
            state.packagesList.showTableData = showTableData;
            state.packagesList.filterTableData = filterTableData;
        }
    },
    extraReducers: {
        [getPackages.fulfilled]: (state, action) => {
            const { subId, id, dr_packageID } = action?.payload?.params;
            const findCropCycleName = action?.payload?.cropCycle?.crop_connect?.cropName ? action?.payload?.cropCycle?.crop_connect?.cropName : ""
            const fetchSinglePackages = (action?.payload?.data)?.filter((n) => parseInt(n?.id) === parseInt(subId))?.length ? (action?.payload?.data)?.filter((n) => parseInt(n?.id) === parseInt(subId))[0]?.name ? (action?.payload?.data)?.filter((n) => parseInt(n?.id) === parseInt(subId))[0]?.name : "" : ""

            if (dr_packageID===null && id) {
                state.packageName= fetchSinglePackages;
                state.cropName=findCropCycleName;
                state.initPackageBread = ([
                    { href: `/eywafarm/cropcycle`, label: `Crops` },
                    { href: `/eywafarm/cropcycle/${id}/packages`, label: `Packages ${(findCropCycleName ? ` (${findCropCycleName}) ` : ``)}` },
                    { href: null, label: `Assign Package ${fetchSinglePackages ? `(${fetchSinglePackages})` : ``}` }
                ])
            } else if (subId && id) {
                state.packageName= fetchSinglePackages;
                state.cropName=findCropCycleName;
                state.initPackageBread = ([
                    { href: `/eywafarm/cropcycle`, label: `Crops` },
                    { href: `/eywafarm/cropcycle/${id}/packages`, label: `Packages ${(findCropCycleName ? ` (${findCropCycleName}) ` : ``)}` },
                    { href: null, label: `Timelines ${fetchSinglePackages ? `(${fetchSinglePackages})` : ``}` }
                ])
            } else {
                state.initPackageBread = ([
                    { href: `/eywafarm/cropcycle`, label: `Crops` },
                    { href: null, label: `Packages ${(findCropCycleName ? ` (${findCropCycleName}) ` : ``)}` }
                ])
            }
            state.packagesTimeLineOption = ((action.payload.data)?.map((n) => ({
                label: n?.name,
                value: n?.id,
                type: n?.type,
                timelines:
                    (n?.package_time_lines)?.map((m) => ({
                        label: m?.name, value: m?.id, data: ({
                            id: "",
                            importTimeLineId: m?.id ? m?.id : "",
                            timelineName: m?.name ? m?.name : "" ,
                            annualFrom: m?.annualFrom ? m?.annualFrom : "0",
                            annualTo: m?.annualTo ? m?.annualTo : "0",
                            units: m?.units ? m?.units : "",
                            packageId: n?.id ? n?.id : "",
                            perennialFrom: m?.perennialFrom ? m?.perennialFrom : "",
                            perennialTo: m?.perennialTo ? m?.perennialTo : ""
                        })
                    }))
            }))).filter((n) => n?.timelines?.length)
            state.selectedConnectId = action?.payload?.cropCycle?.crop_connect?.id ? action?.payload?.cropCycle?.crop_connect?.id : ""

            let finalPackageList = action?.payload.data;
            const { packagesList: { pageIndex, pageSize, query, sort } } = (JSON.parse(JSON.stringify(state)));


            if (query) {
                finalPackageList = finalPackageList?.filter((n) => ((n?.name)?.toLowerCase())?.includes(query));
            }

           if (!sort?.order && !sort?.key) {
            finalPackageList?.sort((a, b) => {
                const dateA = new Date(a?.createdDate || a?.attributes?.createdDate || 0);
                const dateB = new Date(b?.createdDate || b?.attributes?.createdDate || 0);
                return dateB - dateA;
            });
        }else {
                if (sort?.order && sort?.key) {
                    if (sort?.key === 'asc') {
                        finalPackageList?.sort((a, b) => a?.attributes[sort?.key] - b?.attributes[sort?.key]);
                    }
                    if (sort?.key === 'desc') {
                        finalPackageList?.sort((a, b) => b?.attributes[sort?.key] - a?.attributes[sort?.key]);
                    }
                }
            }

            let startIndex = (parseInt(parseInt(pageIndex - 1) * pageSize) ? parseInt(parseInt(parseInt(pageIndex - 1) * pageSize)) : parseInt(parseInt(pageIndex - 1) * pageSize))
            let endIndex = parseInt((pageIndex * pageSize))
            state.packagesList.showTableData = finalPackageList
            state.packagesList.total = finalPackageList.length
            let filterData = finalPackageList?.slice(startIndex, endIndex);
            state.packagesList.filterTableData = filterData
            state.packagesList.loading = false;
        },
        [getPackages.rejected]: (state) => {
            state.packagesList.loading = false
            state.selectedConnectId = ""
        },
        [getPackages.pending]: (state) => {
            state.packagesList.loading = true
            state.selectedConnectId = ""
        },

        [getPackageHistoryList.fulfilled]: (state, action) => {            
            var list = action.payload.data
            state.packageHistoryList = list
        },
        [getPackageHistoryList.rejected]: (state) => {
            state.packageHistoryList = []
        },
        [getPackageHistoryList.pending]: (state) => {
            state.packageHistoryList = []
        },

        // Custom Character Reducers
        [addCustomCharacter.fulfilled]: (state, action) => {
            // Refresh characters list after adding
            state.charactersList = [...state.charactersList]
        },
        
        [updateCustomCharacter.fulfilled]: (state, action) => {
            // Refresh characters list after updating
            state.charactersList = [...state.charactersList]
        },
        
        [deleteCustomCharacter.fulfilled]: (state, action) => {
            // Refresh characters list after deleting
            state.charactersList = [...state.charactersList]
        },

        [getStates.fulfilled]: (state, action) => {
            var modifiedStates = ((action.payload.data)?.map((n) => ({ value: n?.state?.id, label: n?.state?.name, districts: ((action?.payload.data)?.map((nm) => nm?.state?.id === n?.state?.id ? ({ label: nm?.name, value: nm?.id }) : null))?.filter((n) => n) }))).filter((obj, index, self) =>
                index === self.findIndex((t) => (
                    t?.value === obj?.value
                ))
            );
            state.states = modifiedStates
        },
        [getStates.rejected]: (state) => {
            state.states = []
        },
        [getStates.pending]: (state) => {
            state.states = []
        },

        [getCharacters.fulfilled]: (state, action) => {
            var modifiedCharacter = (action.payload.data)?.map((n) => ({ custom: n?.isCustom, label: n?.package_character?.name, value: n?.package_character?.id, optionList: (n?.package_options)?.map((nm) => ({ custom: nm?.isCustom, label: nm?.name, value: nm?.id })) })).filter((obj, index, self) =>
                index === self.findIndex((t) => (
                    t?.value === obj?.value
                ))
            );
            state.charactersList = modifiedCharacter
        },
        [getCharacters.rejected]: (state) => {
            state.charactersList = []
        },
        [getCharacters.pending]: (state) => {
            state.charactersList = []
        },

        [getAuthors.fulfilled]: (state, action) => {
            var modifiedUsers = (((action?.payload?.data?.attributes?.tenePartnerUsers?.data)?.filter((n) => ((((n?.attributes?.tene_partner_user_info?.data?.attributes?.tene_partner_roles?.data))?.map((np) => np?.id))?.includes((parseInt(process.env.REACT_APP_PARTNER_ROLE_Content_Expert_id))))))?.map((n) => ({ label: n?.attributes?.name, designation: n?.attributes?.tene_partner_user_info?.data?.attributes?.designation ? n?.attributes?.tene_partner_user_info?.data?.attributes?.designation : "NA", value: n?.id })))
            state.usersList = modifiedUsers
        },
        [getAuthors.rejected]: (state) => {
            state.usersList = []
        },
        [getAuthors.pending]: (state) => {
            state.usersList = []
        },

        [getDateLabels.fulfilled]: (state, action) => {
            var data = action.payload
            data = data?.data?.map((item)=>  ({label:item?.attributes?.type, value:item?.id}))
            state.dateLabelsList = data
        },
        [getDateLabels.rejected]: (state) => {
            state.dateLabelsList = []
        },
        [getDateLabels.pending]: (state) => {
            state.dateLabelsList = []
        }
    }
})


export const {
    updateFilterData,
    updatePageSize,
    updatePageIndex,
    updateQuery,
    updateIsPackage,
    updateCreateDisctrict,
    updateCharacterOptionMap,
    updatecreateAuthor,
    resetpackageFormData,
    updateAllData,
    updateAllDataLength,
    updateListData
} = packages.actions;

export default packages.reducer

export const savePackages = async (data, SuccessCallBack, ErrorCallBack) => {
    await apisavePackages(data).then(({ status, data: { data, message } }) => {
        if (status && status === 201) {
            SuccessCallBack({ success: true, message: message, data: data })
        } else {
            ErrorCallBack({ success: false, message: message })
        }
    }).catch((error) => {
        if (error?.response?.data?.message) {
            ErrorCallBack({ success: false, message: error?.response?.data?.message })
        } else {
            ErrorCallBack({ success: false, message: error?.message })
        }
    })
}

export const updatePackages = async (data, SuccessCallBack, ErrorCallBack) => {
    await apiUpdatePackages(data?.id, { data: data?.data }).then(({ status, data: { data, message } }) => {
        if (status && status === 200) {
            SuccessCallBack({ success: true, message: message, data: data })
        } else {
            ErrorCallBack({ success: false, message: message })
        }
    }).catch(({ message }) => { ErrorCallBack({ success: false, message: message }) })
}

export const restorePackageVersion = async (data, SuccessCallBack, ErrorCallBack) => {
    await apiRestorePackageVersion(data).then(({ status, data: { data, message } }) => {
        if (status && status === 200) {
            SuccessCallBack({ success: true, message: message, data: data })
        } else {
            ErrorCallBack({ success: false, message: message })
        }
    }).catch(({ message }) => { ErrorCallBack({ success: false, message: message }) })
}

export const publishPacakgeApi = async (data, SuccessCallBack, ErrorCallBack) => {
    await apiPublishPacakge(data).then(({ status, data: { data, message } }) => {
        if (status && status === 200) {
            SuccessCallBack({ success: true, message: message, data: data })
        } else {
            ErrorCallBack({ success: false, message: message })
        }
    }).catch(({ message }) => { ErrorCallBack({ success: false, message: message }) })
}

export const updatePackagesCustom = async (id, data, SuccessCallBack, ErrorCallBack) => {
    await apiUpdatePackagesCustom(id, data).then(({ status, data: { data, message } }) => {
        if (status && status === 200) {
            SuccessCallBack({ success: true, message: message, data: data })
        } else {
            ErrorCallBack({ success: false, message: message })
        }
    }).catch(({ message }) => { ErrorCallBack({ success: false, message: message }) })
}



export const setCharacterOptionMap = async (id, data, SuccessCallBack, ErrorCallBack) => {
    await apiUpdatePackagesCharacterOptionMapCustom(id, data).then(({ status, data: { data, message } }) => {
        if (status && status === 200) {
            SuccessCallBack({ success: true, message: message, data: data })
        } else {
            ErrorCallBack({ success: false, message: message })
        }
    }).catch(({ message }) => { ErrorCallBack({ success: false, message: message }) })
}

export const saveAssignVersionApi = async (data, SuccessCallBack, ErrorCallBack) => {
    await apiSaveAssignVersion(data).then(({ status, data: { data, message } }) => {
        if (status && status === 200) {
            SuccessCallBack({ success: true, message: message, data: data })
        } else {
            ErrorCallBack({ success: false, message: message })
        }
    }).catch(({ message }) => { ErrorCallBack({ success: false, message: message }) })
}